// $.extend($.lazyLoadXT, {
//   edgeY:  200,
//   srcAttr: 'data-src'
// });
$.lazyLoadXT.autoInit=false;
$.lazyLoadXT.updateEvent = 'orientationchange resize scroll touchmove focus';
$.lazyLoadXT.forceLoad=true;
// $.lazyLoadXT.checkDuplicates=true;

bq.global.imageLoader = function() {
  $('[data-bq="image-load"]').each(function(){
    var $this = $(this);

    if (!$this.data('bq.imageLoader')) { //so we dont try and attach event again
        $this.data('bq.imageLoader', true);
        var options = {};
        if ($this.data('show')) {
            options.show = true;
        }

        if ($this.closest('#main-image')) {
           $this.closest('#main-image').removeClass('invalid-zoom'); 
        }

        $this.lazyLoadXT(options);
        $this.on('lazyerror', function(e, img) {
            var image = $(e.target),
                imageType = image.data('imageType');

            if (image.closest('#main-image') && !image.data('image-placeholder-size')) {
               $this.closest('#main-image').addClass('invalid-zoom');
            }

            if (imageType == 'done') {
                return;
            }

            if (imageType == 'user') {
                image.attr('src', bq.urls.image.user.defaultAvatar);
            }

            if (imageType == 'supplier') {
                //lets load the default fallback
                image.attr('src', bq.global.imageHelper.getSupplierPlaceholderImage());
            }

            if (imageType == 'product') {
                image.data('imageType', 'supplier');
                image.attr('src', bq.global.imageHelper.getSupplierImage(image));
            }

            image.on('error', function(e) {
                var image = $(e.target),
                    imageType = image.data('imageType');

                if (imageType == 'done') { return; }
                image.data('imageType', 'done');
                if (image.data('image-placeholder-size') && image.closest('a')) {
                    var smoothLink = image.closest('a');
                    if (smoothLink.data('image-placeholder-size')) {
                        smoothLink.attr('href', bq.global.imageHelper.getSupplierPlaceholderImage(smoothLink.data('image-placeholder-size')));
                    }
                }
                image.attr('src', bq.global.imageHelper.getSupplierPlaceholderImage(image.data('image-placeholder-size')));
            });
        });

        // FireFox catches 'error' event and allows to set SRC attribute
        $this.on('error', function (e) {
            var image = $(e.target),
                imageType = image.data('imageType');

            if (imageType == 'done') { return; }

            if (imageType == 'supplier') {
                image.data('imageType', 'done');
                image.attr('src', bq.global.imageHelper.getSupplierPlaceholderImage(image.data('image-placeholder-size')));
            }
        });
    }
  });
};

bq.init.push(bq.global.imageLoader);

//a few global functions
bq.global.imageHelper = {
    getSupplierUrl: function(file) {
        return bq.urls.image.supplier.path + file;
    },

    getSupplierImage: function(image) {
        var attr = bq.urls.image.supplier.attribute;
        if(!image.data(attr)) {
            if (image.data('image-placeholder-size') && image.closest('a')) {
                var smoothLink = image.closest('a');
                if (smoothLink.data('image-placeholder-size')) {
                    smoothLink.attr('href', this.getSupplierPlaceholderImage(smoothLink.data('image-placeholder-size')));
                }
            }
            return this.getSupplierPlaceholderImage(image.data('image-placeholder-size'));
        }

        var file = image.data(attr) + bq.urls.image.supplier.type;
        return this.getSupplierUrl(file);
    },

    getSupplierPlaceholderImage: function(type) {
        switch (type) {
            case 'image':
                return bq.urls.image.supplier.placeholder.image;
            case 'small_image':
                return bq.urls.image.supplier.placeholder.small_image;
            default:
                return bq.urls.image.supplier.placeholder.thumbnail;
        }
    }
};
